import { fileUploading } from "./fileUploading/en";
import { piForm } from "./PIForm/en";
import { loanApplication } from "./loanApplication/en";

export const TRANSLATION_EN = {
  ...fileUploading,
  ...piForm,
  ...loanApplication,
};
